import { CSpinner } from '@coreui/react-pro';
import React, { Component, Suspense } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
// Redux
import './scss/style.scss';
// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));
const AuthRoute = React.lazy(() => import('./util/AuthRouteFirebase'));
const Login = React.lazy(() => import('./views/auth/Login'));

// const token: string = localStorage.FBIdToken;
// if (token) {
//   const decodedToken: TokenProps = jwt_decode(token);
//   if (decodedToken.exp * 1000 < Date.now()) {
//     store.dispatch(logoutUser());
//     window.location.href = '/';
//   } else {
//     store.dispatch({ type: SET_AUTHENTICATED });
//     api.defaults.headers.common['Authorization'] = token;
//     store.dispatch(getUserData());
//   }
// }

class App extends Component {
  render(): JSX.Element {
    return (
      <HashRouter>
        <Suspense fallback={<CSpinner color="primary" />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <AuthRoute>
                  <DefaultLayout />
                </AuthRoute>
              }
            />
          </Routes>
        </Suspense>
      </HashRouter>
    );
  }
}

export default App;
